export default __webpack_public_path__ + "static/media/graduated.a787564b.png";